import { Capacitor } from '@capacitor/core'
import { API_BASE_URL } from '../api/client'

const DEFAULT_ORIGIN = 'https://rojanamart.in'

/**
 * Resolves an image URL for display in img tags.
 * Handles:
 * - Malformed URLs like https://api/v1/products/images/... or http://api/v1/... (strips the invalid host)
 * - Relative API URLs like /api/v1/products/images/...
 * - Absolute external URLs like https://images.unsplash.com/...
 * - In Capacitor mobile apps, prefixes relative URLs with the backend origin (rojanamart.in)
 */
export function resolveImageUrl(url: string | undefined | null): string {
  if (!url) return ''
  let trimmed = url.trim()
  if (!trimmed) return ''

  // Normalise malformed URLs where http(s):// was prepended to the relative path
  if (trimmed.startsWith('https://api/')) {
    trimmed = '/' + trimmed.substring('https://'.length)
  } else if (trimmed.startsWith('http://api/')) {
    trimmed = '/' + trimmed.substring('http://'.length)
  }

  // Absolute external URLs or data URIs are used directly
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed
  }

  // Ensure relative path has leading slash
  if (!trimmed.startsWith('/')) {
    trimmed = '/' + trimmed
  }

  // Check if running inside Capacitor mobile app / native platform
  const isCapacitorOrNative =
    typeof window !== 'undefined' &&
    (Capacitor.isNativePlatform() ||
      window.location.protocol === 'capacitor:' ||
      (window.location.hostname === 'localhost' && window.location.port !== '5173'))

  const base = (API_BASE_URL || (isCapacitorOrNative ? DEFAULT_ORIGIN : '')).replace(/\/+$/, '')

  return base ? `${base}${trimmed}` : trimmed
}

